export const ATTIVITA_OPTIONS = [
    "ATTI DEL GOVERNO",
    "ATTI DEL PRESIDENTE",
    "AUTORIZZAZIONE A PROCEDERE",
    "COMMEMORAZIONI",
    "COMMISSIONI DI INDAGINI",
    "DELIBERAZIONI",
    "INTERPELLANZE (annuncio)",
    "INTERPELLANZE (rinvio)",
    "INTERPELLANZE (svolgimento)",
    "INTERPELLANZE URGENTI (annuncio)",
    "INTERPELLANZE URGENTI (svolgimento)",
    "INTERROGAZIONI (annuncio)",
    "INTERROGAZIONI CON RISPOSTA SCRITTA (annuncio)",
    "INTERROGAZIONI CON RISPOSTA SCRITTA (risposta pervenuta)",
    "INTERROGAZIONI (decadenza)",
    "INTERROGAZIONI (rinvio)",
    "INTERROGAZIONI (ritiro)",
    "INTERROGAZIONI (svolgimento)",
    "INTERROGAZIONI URGENTI (annuncio)",
    "INTERROGAZIONI URGENTI (svolgimento)",
    "INTERVENTI VARI",
    "MOZIONI (annuncio)",
    "MOZIONI (svolgimento)",
    "RELAZIONI E PROPOSTE",
    "Ripartizione dei componenti la Commissione nelle tre Sottocommissioni",
    "VERIFICA DI POTERI",
    "VOTAZIONI (a scrutinio segreto)",
    "VOTAZIONI (per appello nominale)",
    "VOTAZIONI (per schede)"
];


